$(function () {
    $("a.sharer").click(function(evt) {
        let data = $(this).data();
       
        let targetUrl = data.shareUrl.replace("YOUR_URL_HERE", window.location.href);

        if ($(this).hasClass('mail')) {
            targetUrl = "mailto:?subject=" + document.title + "&body=" + window.location.href;
            window.open(targetUrl);
            return;
        }
        
        window.open(targetUrl, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=500,width=700');
    })
})
